import { Controller } from 'stimulus'
import {  } from 'lightgallery.js/dist/js/lightgallery.min.js'

export default class extends Controller {
  static targets = [ 'swipe', 'slide', 'bg', 'close', 'hide' ]

  connect() {
    lightGallery(this.element, {
        selector: '.slide',
    });
  }
}
